"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userIsCandidateUser = exports.EmploymentAuthorizationType = void 0;
const user_shared_1 = require("@engineering11/user-shared");
var EmploymentAuthorizationType;
(function (EmploymentAuthorizationType) {
    EmploymentAuthorizationType["Permanent"] = "permanent";
    EmploymentAuthorizationType["Temporary"] = "temporary";
})(EmploymentAuthorizationType = exports.EmploymentAuthorizationType || (exports.EmploymentAuthorizationType = {}));
const userIsCandidateUser = (user) => user.userType === user_shared_1.UserType.Consumer;
exports.userIsCandidateUser = userIsCandidateUser;
